import React from "react";
import "./CounterUpNumeros.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const CounterUpNumeros = () => {
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  const formatNumber = (number) => {
    return number.toLocaleString("de-DE"); // Formato para separadores de miles con puntos
  };

  return (
    <div ref={ref} className="transparent-box">
      <div className="stats-container">        
        <div className="stat-box">          
          <div className="stat-number">           
            {inView ? (
              <CountUp
                start={0}
                end={96}
                duration={2}
                delay={0}
                formattingFn={formatNumber}
              />
            ) : (
              0
            )}
            %
          </div>
          <div className="stat-description">
            
            de nuestros clientes factoring fueron PYMES y micro empresas
          </div>
        </div>
        <div className="stat-box">
         
          <div className="stat-number">
            
            {inView ? (
              <CountUp
                start={0}
                end={61}
                duration={2}
                delay={0}
                formattingFn={formatNumber}
              />
            ) : (
              0
            )}
          </div>
          <div className="stat-description">
            millones de dólares en colocaciones a nivel consolidado
          </div>
        </div>
        <div className="stat-box">          
          <div className="stat-number">            
            {inView ? (
              <CountUp
                start={0}
                end={3569}
                duration={2}
                delay={0}
                formattingFn={formatNumber}
              />
            ) : (
              0
            )}
          </div>
          <div className="stat-description">
            clientes atendidos desde que iniciamos operaciones
          </div>
        </div>
        <div className="stat-box">
          <div className="stat-number">            
            {inView ? (
              <CountUp
                start={0}
                end={1199}
                duration={2}
                delay={0}
                formattingFn={formatNumber}
              />
            ) : (
              0
            )}
          </div>
          <div className="stat-description">
            millones de dólares en flujo de negocios realizados
          </div>
        </div>
        <div className="stat-box">
          <div className="stat-number">            
            +
            {inView ? (
              <CountUp
                start={0}
                end={26000}
                duration={2}
                delay={0}
                formattingFn={formatNumber}
              />
            ) : (
              0
            )}
          </div>
          <div className="stat-description">
            operaciones cursadas desde nuestros inicios
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterUpNumeros;
